import moment from 'moment';

class CampaignUtils {
	constructor() {
		this.campaignData = {};
		this.sourceData = {};
	}

	checkExist(searchString) {
		const campaignData = {};
    const searchParams = new URLSearchParams(searchString);
    const utmFields = [
			'utm_campaign', 
			'utm_medium', 
			'utm_source', 
			'utm_term', 
			'utm_content', 
			'utm_prom'
		];
    
    utmFields.forEach(field => {
			if (searchParams.has(field)) {
				const fieldValues = searchParams.getAll(field);
				campaignData[field] = fieldValues.join(', ');
			}
		});

    this.campaignData = campaignData;
		const hasCampaignData = Object.keys(campaignData).length > 0;

    return hasCampaignData;
	}

	checkExistInStorage(campaign) {
		let campaignExist = false;
		let utmCampaign = null;
		let utmSource = null;
		let utmMedium = null;
		let utmContent = null;
		let utmTerm = null;
		let prom = null;
		let promDate = null;
		let order = null;
		let email = null;
		if (this.checkExist(campaign)) {
			const campaignData = this.campaignData;
        	utmCampaign = campaignData.utm_campaign || utmCampaign;
        	utmSource = campaignData.utm_source || utmSource;
        	utmMedium = campaignData.utm_medium || utmMedium;
        	utmTerm = campaignData.utm_term || utmTerm;
        	utmContent = campaignData.utm_content || utmContent;
        	prom = campaignData.utm_prom || prom;
			order = campaignData.order || order;
			email = campaignData.email || email;
		}
		const formulario_de_conversao =
			sessionStorage.getItem('formulario_de_conversao') ||
			localStorage.getItem('formulario_de_conversao') ||
			'pedido_iniciado';

		if (
			sessionStorage.getItem('yaloProm') ||
			localStorage.getItem('yaloProm')
		) {
			prom = sessionStorage.getItem('yaloProm');
			promDate =
				sessionStorage.getItem('yaloPromDate') ||
				localStorage.getItem('yaloPromDate') ||
				null;
			if (promDate) {
				promDate = promDate.replace('/', '-').replace('/', '-');
				promDate =
					moment(promDate, 'DD-MM-YYYY') || moment().format('DD/MM/YYYY');
			}
		}

		if (utmSource && utmSource.includes('FVP')) {
			const ontemFormatado = moment(new Date(), 'DD/MM/YYYY').subtract(2, 'd');
			// já venceu o limite para promotora ganhar
			if (!ontemFormatado.isBefore(promDate)) {
				utmCampaign = null;
				utmSource = null;
				utmMedium = null;
			}
		}

		campaignExist = true;
		this.campaignData = {
			utmCampaign,
			utmSource,
			utmMedium,
			prom,
			promDate,
			formulario_de_conversao,
			utmContent,
			utmTerm,
			order,
			email
		};
		console.log(this.campaignData);

		return campaignExist;
	}

	checkSource(searchString) {
		let searchArray = searchString.replace('?', '').split('&');
		let utmSource = false;

		let searchObj = {};
		searchArray.forEach(item => {
			let itemArray = item.split('=');
			searchObj[itemArray[0]] = itemArray[1];
		});

		if (searchObj.utm_source) {
			utmSource = true;
			this.sourceData = searchObj;
		}

		return utmSource;
	}
	getPlanType(searchString) {
		let searchArray = searchString.replace('?', '').split('&');
		let searchObj = {};
		searchArray.forEach(item => {
			let itemArray = item.split('=');
			searchObj[itemArray[0]] = itemArray[1].trim();
		});

		return searchObj.assinatura;
	}
	getSignatureTypeAndPeriod(searchString) {
		let searchArray = searchString.replace('?', '').split('&');
		let searchObj = {};
		searchArray.forEach(item => {
			let itemArray = item.split('=');
			searchObj[itemArray[0]] = itemArray[1].trim();
		});

		return searchObj;
	}

	getSignatureTypeAndPlanId(searchString) {
		let searchArray = searchString.replace('?', '').split('&');
		let searchObj = {};
		searchArray.forEach(item => {
			let itemArray = item.split('=');
			searchObj[itemArray[0]] = itemArray[1].trim();
		});

		return searchObj;
	}

	getEdit(searchString) {
		let searchArray = searchString.replace('?', '').split('&');
		let searchObj = {};
		searchArray.forEach(item => {
			let itemArray = item.split('=');
			searchObj[itemArray[0]] = itemArray[1].trim();
		});
		return searchObj.isediting;
	}
	getPlan(searchString) {
		let searchArray = searchString.replace('?', '').split('&');
		let searchObj = {};
		searchArray.forEach(item => {
			let itemArray = item.split('=');
			searchObj[itemArray[0]] = itemArray[1].trim();
		});

		return searchObj.planId;
	}

	getData() {
		return this.campaignData;
	}

	getSource() {
		return this.sourceData;
	}
}

export default new CampaignUtils();
